import {
    forwardRef,
    ForwardRefExoticComponent,
    ReactElement,
    Ref,
    RefAttributes,
} from 'react';

import classNames from 'classnames';

import './Input.scss';

interface InputProps extends RefAttributes<HTMLInputElement> {
    error?: string;
}

export type HTMLInputProps = JSX.IntrinsicElements['input'] & InputProps;

const Input: ForwardRefExoticComponent<HTMLInputProps> = forwardRef(({
    type,
    error = '',
    className = '',
    ...inputProps
}, ref: Ref<HTMLInputElement>): ReactElement => {
    const inputClassNames = classNames('input', className, {
        'input--has-error': !!error,
    });

    return (
        <input
            {...inputProps}
            ref={ref}
            type={type || 'text'}
            className={inputClassNames}
        />
    );
});

export default Input;
